// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Azure AD Groups Management - Main Container */
.azure-ad-groups-container {
  padding: 24px;
  max-width: 1400px;
  margin: 0 auto;
  background: #f5f7fa;
  min-height: 100vh;
}

/* Page Header */
.azure-ad-groups-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.azure-ad-groups-header h1 {
  margin: 0;
  font-size: 28px;
  color: #1a202c;
  font-weight: 600;
}

.header-actions {
  display: flex;
  gap: 12px;
}

.header-actions button {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-primary {
  background: #3182ce;
  color: white;
}

.btn-primary:hover {
  background: #2c5aa0;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(49, 130, 206, 0.3);
}

.btn-secondary {
  background: #e2e8f0;
  color: #4a5568;
}

.btn-secondary:hover {
  background: #cbd5e0;
}

.btn-success {
  background: #48bb78;
  color: white;
}

.btn-success:hover {
  background: #38a169;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(72, 187, 120, 0.3);
}

.btn-danger {
  background: #f56565;
  color: white;
}

.btn-danger:hover {
  background: #e53e3e;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(245, 101, 101, 0.3);
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

button:disabled:hover {
  transform: none;
  box-shadow: none;
}

/* Filters Section */
.filters-section {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 24px;
  display: flex;
  gap: 20px;
  align-items: center;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.filter-group label {
  font-size: 14px;
  font-weight: 500;
  color: #4a5568;
}

.filter-group select {
  padding: 8px 12px;
  border: 1px solid #cbd5e0;
  border-radius: 6px;
  font-size: 14px;
  min-width: 200px;
  cursor: pointer;
}

.filter-group select:focus {
  outline: none;
  border-color: #3182ce;
  box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);
}

.checkbox-filter {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 20px;
}

.checkbox-filter input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.checkbox-filter label {
  font-size: 14px;
  font-weight: 500;
  color: #4a5568;
  cursor: pointer;
}

/* Groups Table */
.groups-table-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.groups-table {
  width: 100%;
  border-collapse: collapse;
}

.groups-table thead {
  background: #edf2f7;
}

.groups-table th {
  padding: 16px;
  text-align: left;
  font-size: 13px;
  font-weight: 600;
  color: #2d3748;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #cbd5e0;
}

.groups-table tbody tr {
  border-bottom: 1px solid #e2e8f0;
  transition: background-color 0.2s ease;
}

.groups-table tbody tr:hover {
  background: #f7fafc;
}

.groups-table tbody tr.inactive-row {
  opacity: 0.6;
  background: #fafafa;
}

.groups-table td {
  padding: 16px;
  font-size: 14px;
  color: #4a5568;
}

.group-name-cell strong {
  color: #1a202c;
  font-size: 15px;
  display: block;
  margin-bottom: 4px;
}

.group-description {
  color: #718096;
  font-size: 13px;
  margin-top: 4px;
}

.group-id {
  font-family: 'Courier New', monospace;
  font-size: 12px;
  color: #718096;
  display: block;
  margin-top: 2px;
}

/* Status Badges */
.status-badge,
.role-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-badge.active {
  background: #c6f6d5;
  color: #22543d;
}

.status-badge.inactive {
  background: #fed7d7;
  color: #742a2a;
}

.role-badge.uar-admin {
  background: #bee3f8;
  color: #2c5282;
}

.role-badge.dev-admin {
  background: #feebc8;
  color: #7c2d12;
}

.role-badge.attester {
  background: #e9d8fd;
  color: #44337a;
}

.role-badge.unmapped {
  background: #e2e8f0;
  color: #4a5568;
}

/* Yes/No Indicators */
.indicator-yes {
  color: #48bb78;
  font-weight: 600;
}

.indicator-no {
  color: #a0aec0;
}

/* Action Buttons */
.action-buttons {
  display: flex;
  gap: 8px;
}

.action-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.action-btn.view {
  background: #bee3f8;
  color: #2c5282;
}

.action-btn.view:hover {
  background: #90cdf4;
}

.action-btn.edit {
  background: #feebc8;
  color: #7c2d12;
}

.action-btn.edit:hover {
  background: #fbd38d;
}

.action-btn.sync {
  background: #c6f6d5;
  color: #22543d;
}

.action-btn.sync:hover {
  background: #9ae6b4;
}

.action-btn.delete {
  background: #fed7d7;
  color: #742a2a;
}

.action-btn.delete:hover {
  background: #fc8181;
}

/* Modals */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.modal-content {
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  max-width: 600px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.modal-content.wide {
  max-width: 900px;
}

.modal-header {
  padding: 24px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h2 {
  margin: 0;
  font-size: 22px;
  color: #1a202c;
  font-weight: 600;
}

.modal-close {
  background: none;
  border: none;
  font-size: 24px;
  color: #a0aec0;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.modal-close:hover {
  background: #f7fafc;
  color: #4a5568;
}

.modal-body {
  padding: 24px;
}

.modal-footer {
  padding: 20px 24px;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

/* Forms */
.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #2d3748;
  margin-bottom: 8px;
}

.form-group input[type="text"],
.form-group textarea,
.form-group select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #cbd5e0;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.form-group input[type="text"]:focus,
.form-group textarea:focus,
.form-group select:focus {
  outline: none;
  border-color: #3182ce;
  box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);
}

.form-group input[type="text"]:disabled {
  background: #edf2f7;
  cursor: not-allowed;
}

.form-group textarea {
  resize: vertical;
  min-height: 80px;
  font-family: inherit;
}

.checkbox-group {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
}

.checkbox-group input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.checkbox-group label {
  font-size: 14px;
  font-weight: 500;
  color: #4a5568;
  cursor: pointer;
  margin: 0;
}

.form-help-text {
  font-size: 13px;
  color: #718096;
  margin-top: 4px;
}

/* Members Table */
.members-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 16px;
}

.members-table thead {
  background: #f7fafc;
}

.members-table th {
  padding: 12px;
  text-align: left;
  font-size: 13px;
  font-weight: 600;
  color: #2d3748;
  border-bottom: 2px solid #e2e8f0;
}

.members-table tbody tr {
  border-bottom: 1px solid #e2e8f0;
}

.members-table tbody tr.inactive-member {
  opacity: 0.5;
}

.members-table td {
  padding: 12px;
  font-size: 14px;
  color: #4a5568;
}

.members-count {
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 16px;
}

/* Sync Results Display */
.sync-results {
  margin-top: 20px;
  padding: 16px;
  background: #f7fafc;
  border-radius: 8px;
  border-left: 4px solid #3182ce;
}

.sync-results h3 {
  margin: 0 0 12px 0;
  font-size: 16px;
  color: #2d3748;
}

.sync-stat {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #e2e8f0;
}

.sync-stat:last-child {
  border-bottom: none;
}

.sync-stat-label {
  font-size: 14px;
  color: #4a5568;
}

.sync-stat-value {
  font-size: 14px;
  font-weight: 600;
  color: #2d3748;
}

.sync-stat-value.success {
  color: #38a169;
}

.sync-stat-value.error {
  color: #e53e3e;
}

/* Alert Messages */
.azure-ad-groups-container .alert {
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  animation: slideDown 0.3s ease;
}

@keyframes slideDown {
  from {
    transform: translateY(-10px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.azure-ad-groups-container .alert-success {
  background: #c6f6d5;
  color: #22543d;
  border-left: 4px solid #38a169;
}

.azure-ad-groups-container .alert-error {
  background: #fed7d7;
  color: #742a2a;
  border-left: 4px solid #e53e3e;
}

.azure-ad-groups-container .alert-icon {
  font-size: 20px;
}

.azure-ad-groups-container .alert-message {
  flex: 1 1;
  font-size: 14px;
  font-weight: 500;
}

/* Loading State */
.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}

.loading-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid #e2e8f0;
  border-top-color: #3182ce;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.loading p {
  margin-top: 16px;
  font-size: 16px;
  color: #718096;
}

/* Empty State */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  background: white;
  border-radius: 8px;
}

.empty-state-icon {
  font-size: 64px;
  color: #cbd5e0;
  margin-bottom: 16px;
}

.empty-state h3 {
  margin: 0 0 8px 0;
  font-size: 20px;
  color: #2d3748;
}

.empty-state p {
  margin: 0;
  font-size: 14px;
  color: #718096;
}

/* Delete Confirmation */
.delete-confirmation {
  text-align: center;
}

.delete-warning-icon {
  font-size: 48px;
  color: #f56565;
  margin-bottom: 16px;
}

.delete-confirmation p {
  font-size: 16px;
  color: #4a5568;
  margin-bottom: 8px;
}

.delete-confirmation .group-name-highlight {
  font-weight: 600;
  color: #1a202c;
}

.delete-confirmation .member-warning {
  margin-top: 16px;
  padding: 12px;
  background: #fef5e7;
  border-radius: 6px;
  border-left: 3px solid #f6ad55;
  font-size: 14px;
  color: #744210;
}

/* Group Info Display */
.group-info {
  background: #f7fafc;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.group-info-row {
  display: flex;
  padding: 8px 0;
  border-bottom: 1px solid #e2e8f0;
}

.group-info-row:last-child {
  border-bottom: none;
}

.group-info-label {
  flex: 0 0 150px;
  font-size: 14px;
  font-weight: 600;
  color: #4a5568;
}

.group-info-value {
  flex: 1 1;
  font-size: 14px;
  color: #2d3748;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .groups-table {
    font-size: 13px;
  }

  .groups-table th,
  .groups-table td {
    padding: 12px;
  }
}

@media (max-width: 768px) {
  .azure-ad-groups-container {
    padding: 16px;
  }

  .azure-ad-groups-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .header-actions {
    width: 100%;
    flex-direction: column;
  }

  .header-actions button {
    width: 100%;
    justify-content: center;
  }

  .filters-section {
    flex-direction: column;
    align-items: stretch;
  }

  .filter-group select {
    width: 100%;
  }

  .groups-table-container {
    overflow-x: auto;
  }

  .groups-table {
    min-width: 800px;
  }

  .modal-content {
    width: 95%;
    margin: 20px;
  }

  .action-buttons {
    flex-direction: column;
  }

  .action-btn {
    width: 100%;
  }
}

/* Utility Classes */
.text-muted {
  color: #718096;
}

.text-bold {
  font-weight: 600;
}

.text-center {
  text-align: center;
}

.mt-2 {
  margin-top: 16px;
}

.mb-2 {
  margin-bottom: 16px;
}

.p-0 {
  padding: 0;
}

/* Tooltips */
[title] {
  position: relative;
  cursor: help;
}

/* Focus visible for accessibility */
button:focus-visible,
input:focus-visible,
select:focus-visible,
textarea:focus-visible {
  outline: 2px solid #3182ce;
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/AzureADGroups.css"],"names":[],"mappings":"AAAA,gDAAgD;AAChD;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA,kBAAkB;AAClB;;EAEE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qFAAqF;EACrF,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,wDAAwD;AAC1D;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,oBAAoB;AACpB;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA,oCAAoC;AACpC;;;;EAIE,0BAA0B;EAC1B,mBAAmB;AACrB","sourcesContent":["/* Azure AD Groups Management - Main Container */\n.azure-ad-groups-container {\n  padding: 24px;\n  max-width: 1400px;\n  margin: 0 auto;\n  background: #f5f7fa;\n  min-height: 100vh;\n}\n\n/* Page Header */\n.azure-ad-groups-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  padding: 20px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.azure-ad-groups-header h1 {\n  margin: 0;\n  font-size: 28px;\n  color: #1a202c;\n  font-weight: 600;\n}\n\n.header-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.header-actions button {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.btn-primary {\n  background: #3182ce;\n  color: white;\n}\n\n.btn-primary:hover {\n  background: #2c5aa0;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(49, 130, 206, 0.3);\n}\n\n.btn-secondary {\n  background: #e2e8f0;\n  color: #4a5568;\n}\n\n.btn-secondary:hover {\n  background: #cbd5e0;\n}\n\n.btn-success {\n  background: #48bb78;\n  color: white;\n}\n\n.btn-success:hover {\n  background: #38a169;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(72, 187, 120, 0.3);\n}\n\n.btn-danger {\n  background: #f56565;\n  color: white;\n}\n\n.btn-danger:hover {\n  background: #e53e3e;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(245, 101, 101, 0.3);\n}\n\nbutton:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\nbutton:disabled:hover {\n  transform: none;\n  box-shadow: none;\n}\n\n/* Filters Section */\n.filters-section {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  margin-bottom: 24px;\n  display: flex;\n  gap: 20px;\n  align-items: center;\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.filter-group label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #4a5568;\n}\n\n.filter-group select {\n  padding: 8px 12px;\n  border: 1px solid #cbd5e0;\n  border-radius: 6px;\n  font-size: 14px;\n  min-width: 200px;\n  cursor: pointer;\n}\n\n.filter-group select:focus {\n  outline: none;\n  border-color: #3182ce;\n  box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);\n}\n\n.checkbox-filter {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 20px;\n}\n\n.checkbox-filter input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n.checkbox-filter label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #4a5568;\n  cursor: pointer;\n}\n\n/* Groups Table */\n.groups-table-container {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.groups-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.groups-table thead {\n  background: #edf2f7;\n}\n\n.groups-table th {\n  padding: 16px;\n  text-align: left;\n  font-size: 13px;\n  font-weight: 600;\n  color: #2d3748;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-bottom: 2px solid #cbd5e0;\n}\n\n.groups-table tbody tr {\n  border-bottom: 1px solid #e2e8f0;\n  transition: background-color 0.2s ease;\n}\n\n.groups-table tbody tr:hover {\n  background: #f7fafc;\n}\n\n.groups-table tbody tr.inactive-row {\n  opacity: 0.6;\n  background: #fafafa;\n}\n\n.groups-table td {\n  padding: 16px;\n  font-size: 14px;\n  color: #4a5568;\n}\n\n.group-name-cell strong {\n  color: #1a202c;\n  font-size: 15px;\n  display: block;\n  margin-bottom: 4px;\n}\n\n.group-description {\n  color: #718096;\n  font-size: 13px;\n  margin-top: 4px;\n}\n\n.group-id {\n  font-family: 'Courier New', monospace;\n  font-size: 12px;\n  color: #718096;\n  display: block;\n  margin-top: 2px;\n}\n\n/* Status Badges */\n.status-badge,\n.role-badge {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.status-badge.active {\n  background: #c6f6d5;\n  color: #22543d;\n}\n\n.status-badge.inactive {\n  background: #fed7d7;\n  color: #742a2a;\n}\n\n.role-badge.uar-admin {\n  background: #bee3f8;\n  color: #2c5282;\n}\n\n.role-badge.dev-admin {\n  background: #feebc8;\n  color: #7c2d12;\n}\n\n.role-badge.attester {\n  background: #e9d8fd;\n  color: #44337a;\n}\n\n.role-badge.unmapped {\n  background: #e2e8f0;\n  color: #4a5568;\n}\n\n/* Yes/No Indicators */\n.indicator-yes {\n  color: #48bb78;\n  font-weight: 600;\n}\n\n.indicator-no {\n  color: #a0aec0;\n}\n\n/* Action Buttons */\n.action-buttons {\n  display: flex;\n  gap: 8px;\n}\n\n.action-btn {\n  padding: 6px 12px;\n  border: none;\n  border-radius: 4px;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.action-btn.view {\n  background: #bee3f8;\n  color: #2c5282;\n}\n\n.action-btn.view:hover {\n  background: #90cdf4;\n}\n\n.action-btn.edit {\n  background: #feebc8;\n  color: #7c2d12;\n}\n\n.action-btn.edit:hover {\n  background: #fbd38d;\n}\n\n.action-btn.sync {\n  background: #c6f6d5;\n  color: #22543d;\n}\n\n.action-btn.sync:hover {\n  background: #9ae6b4;\n}\n\n.action-btn.delete {\n  background: #fed7d7;\n  color: #742a2a;\n}\n\n.action-btn.delete:hover {\n  background: #fc8181;\n}\n\n/* Modals */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  animation: fadeIn 0.2s ease;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.modal-content {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  max-width: 600px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  animation: slideUp 0.3s ease;\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(20px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.modal-content.wide {\n  max-width: 900px;\n}\n\n.modal-header {\n  padding: 24px;\n  border-bottom: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.modal-header h2 {\n  margin: 0;\n  font-size: 22px;\n  color: #1a202c;\n  font-weight: 600;\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  font-size: 24px;\n  color: #a0aec0;\n  cursor: pointer;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: all 0.2s ease;\n}\n\n.modal-close:hover {\n  background: #f7fafc;\n  color: #4a5568;\n}\n\n.modal-body {\n  padding: 24px;\n}\n\n.modal-footer {\n  padding: 20px 24px;\n  border-top: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n/* Forms */\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  color: #2d3748;\n  margin-bottom: 8px;\n}\n\n.form-group input[type=\"text\"],\n.form-group textarea,\n.form-group select {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #cbd5e0;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.form-group input[type=\"text\"]:focus,\n.form-group textarea:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: #3182ce;\n  box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);\n}\n\n.form-group input[type=\"text\"]:disabled {\n  background: #edf2f7;\n  cursor: not-allowed;\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 80px;\n  font-family: inherit;\n}\n\n.checkbox-group {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.checkbox-group input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n.checkbox-group label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #4a5568;\n  cursor: pointer;\n  margin: 0;\n}\n\n.form-help-text {\n  font-size: 13px;\n  color: #718096;\n  margin-top: 4px;\n}\n\n/* Members Table */\n.members-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 16px;\n}\n\n.members-table thead {\n  background: #f7fafc;\n}\n\n.members-table th {\n  padding: 12px;\n  text-align: left;\n  font-size: 13px;\n  font-weight: 600;\n  color: #2d3748;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.members-table tbody tr {\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.members-table tbody tr.inactive-member {\n  opacity: 0.5;\n}\n\n.members-table td {\n  padding: 12px;\n  font-size: 14px;\n  color: #4a5568;\n}\n\n.members-count {\n  font-weight: 600;\n  color: #2d3748;\n  margin-bottom: 16px;\n}\n\n/* Sync Results Display */\n.sync-results {\n  margin-top: 20px;\n  padding: 16px;\n  background: #f7fafc;\n  border-radius: 8px;\n  border-left: 4px solid #3182ce;\n}\n\n.sync-results h3 {\n  margin: 0 0 12px 0;\n  font-size: 16px;\n  color: #2d3748;\n}\n\n.sync-stat {\n  display: flex;\n  justify-content: space-between;\n  padding: 8px 0;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.sync-stat:last-child {\n  border-bottom: none;\n}\n\n.sync-stat-label {\n  font-size: 14px;\n  color: #4a5568;\n}\n\n.sync-stat-value {\n  font-size: 14px;\n  font-weight: 600;\n  color: #2d3748;\n}\n\n.sync-stat-value.success {\n  color: #38a169;\n}\n\n.sync-stat-value.error {\n  color: #e53e3e;\n}\n\n/* Alert Messages */\n.azure-ad-groups-container .alert {\n  padding: 16px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  animation: slideDown 0.3s ease;\n}\n\n@keyframes slideDown {\n  from {\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.azure-ad-groups-container .alert-success {\n  background: #c6f6d5;\n  color: #22543d;\n  border-left: 4px solid #38a169;\n}\n\n.azure-ad-groups-container .alert-error {\n  background: #fed7d7;\n  color: #742a2a;\n  border-left: 4px solid #e53e3e;\n}\n\n.azure-ad-groups-container .alert-icon {\n  font-size: 20px;\n}\n\n.azure-ad-groups-container .alert-message {\n  flex: 1;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n/* Loading State */\n.loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  text-align: center;\n}\n\n.loading-spinner {\n  width: 48px;\n  height: 48px;\n  border: 4px solid #e2e8f0;\n  border-top-color: #3182ce;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.loading p {\n  margin-top: 16px;\n  font-size: 16px;\n  color: #718096;\n}\n\n/* Empty State */\n.empty-state {\n  text-align: center;\n  padding: 60px 20px;\n  background: white;\n  border-radius: 8px;\n}\n\n.empty-state-icon {\n  font-size: 64px;\n  color: #cbd5e0;\n  margin-bottom: 16px;\n}\n\n.empty-state h3 {\n  margin: 0 0 8px 0;\n  font-size: 20px;\n  color: #2d3748;\n}\n\n.empty-state p {\n  margin: 0;\n  font-size: 14px;\n  color: #718096;\n}\n\n/* Delete Confirmation */\n.delete-confirmation {\n  text-align: center;\n}\n\n.delete-warning-icon {\n  font-size: 48px;\n  color: #f56565;\n  margin-bottom: 16px;\n}\n\n.delete-confirmation p {\n  font-size: 16px;\n  color: #4a5568;\n  margin-bottom: 8px;\n}\n\n.delete-confirmation .group-name-highlight {\n  font-weight: 600;\n  color: #1a202c;\n}\n\n.delete-confirmation .member-warning {\n  margin-top: 16px;\n  padding: 12px;\n  background: #fef5e7;\n  border-radius: 6px;\n  border-left: 3px solid #f6ad55;\n  font-size: 14px;\n  color: #744210;\n}\n\n/* Group Info Display */\n.group-info {\n  background: #f7fafc;\n  padding: 16px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n}\n\n.group-info-row {\n  display: flex;\n  padding: 8px 0;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.group-info-row:last-child {\n  border-bottom: none;\n}\n\n.group-info-label {\n  flex: 0 0 150px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #4a5568;\n}\n\n.group-info-value {\n  flex: 1;\n  font-size: 14px;\n  color: #2d3748;\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .groups-table {\n    font-size: 13px;\n  }\n\n  .groups-table th,\n  .groups-table td {\n    padding: 12px;\n  }\n}\n\n@media (max-width: 768px) {\n  .azure-ad-groups-container {\n    padding: 16px;\n  }\n\n  .azure-ad-groups-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n\n  .header-actions {\n    width: 100%;\n    flex-direction: column;\n  }\n\n  .header-actions button {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .filters-section {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .filter-group select {\n    width: 100%;\n  }\n\n  .groups-table-container {\n    overflow-x: auto;\n  }\n\n  .groups-table {\n    min-width: 800px;\n  }\n\n  .modal-content {\n    width: 95%;\n    margin: 20px;\n  }\n\n  .action-buttons {\n    flex-direction: column;\n  }\n\n  .action-btn {\n    width: 100%;\n  }\n}\n\n/* Utility Classes */\n.text-muted {\n  color: #718096;\n}\n\n.text-bold {\n  font-weight: 600;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.mt-2 {\n  margin-top: 16px;\n}\n\n.mb-2 {\n  margin-bottom: 16px;\n}\n\n.p-0 {\n  padding: 0;\n}\n\n/* Tooltips */\n[title] {\n  position: relative;\n  cursor: help;\n}\n\n/* Focus visible for accessibility */\nbutton:focus-visible,\ninput:focus-visible,\nselect:focus-visible,\ntextarea:focus-visible {\n  outline: 2px solid #3182ce;\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
